module.exports = __webpack_public_path__ + "img/icon-certificate-w.25c020d6.svg";